/**
 * NewChatPage
 * Authenticated "start a new chat" screen — mirrors the landing page layout
 * but lives inside the main Layout (with sidebar).
 */

import React from 'react';
import { ChatInputScreen } from '../components/chat/ChatInputScreen';
import { AmbientBackground } from '../components/backgrounds/AmbientBackground';
import { useAuth } from '../contexts/AuthContext';
import { useStartNewChat } from '../hooks/useStartNewChat';

const NewChatPage: React.FC = () => {
  const { isAnonymous } = useAuth();
  const { isBusy, executionMode, setExecutionMode, handleSend, handleStartRealtimeVoice } =
    useStartNewChat();

  return (
    <div className="relative flex h-full min-h-screen items-center justify-center overflow-hidden bg-gray-50 px-4 dark:bg-[#07111f]">
      <AmbientBackground />
      <div className="relative z-10 w-full">
        <ChatInputScreen
          onSend={handleSend}
          isSubmitting={isBusy}
          executionMode={executionMode}
          onExecutionModeChange={setExecutionMode}
          voiceInputEnabled={!isAnonymous}
          onStartRealtimeVoice={isAnonymous ? undefined : handleStartRealtimeVoice}
          multipleAttachments={false}
        />
      </div>
    </div>
  );
};

export default NewChatPage;
